import React from "react";
import {Col, Row} from "antd";
import PropTypes from "prop-types";

import CarDetailsCard from "./CarDetailsCard";
import CarSpecsCard from "./CarSpecsCard";
import ErrorBoundary from "../ErrorBoundary";

import {reviewCardStyle} from "../../assets/styles";

const CarReviewCardsWrapper = (props) => {
    return (
        <ErrorBoundary>
            <Row type="flex" justify="center" gutter={{sm: 16}}>
                <Col xs={24} sm={12}>
                    <CarDetailsCard
                        car={props.car}
                        isStaff={true}
                        onEdit={false}
                        style={reviewCardStyle}
                    />
                </Col>
                <Col xs={24} sm={12}>
                    <CarSpecsCard
                        car={props.car}
                        isStaff={true}
                        onEdit={false}
                        style={reviewCardStyle}
                    />
                </Col>
            </Row>
        </ErrorBoundary>
    )
}

export default CarReviewCardsWrapper;

CarReviewCardsWrapper.propTypes = {
    car: PropTypes.shape({
        number: PropTypes.number,
        friendly_name: PropTypes.string,
        licence_plate: PropTypes.string,
        vin: PropTypes.string,
        colour: PropTypes.string,
        make: PropTypes.string,
        model: PropTypes.string,
        year: PropTypes.number,
        seats: PropTypes.number,
    }).isRequired,
}